<!--
  AuthShell: shared frame of the public login pages – brand, centered content (slot), link back to the login.
  Pages put their cards into the slot and import components/auth/auth.css for the card building blocks.
-->
<template>
  <div class="acq-bg au-bg">
    <main class="au-page mx-auto px-4 d-flex flex-column">
      <div class="au-brand">
        <span aria-hidden="true" class="au-logo">m</span>
        <span class="au-word">mymusicschool<small>Vanilla · Team-Zugang</small></span>
      </div>
      <slot/>
      <div v-if="loginLink" class="au-foot">
        <router-link class="au-link" to="/login">Zum Login</router-link>
      </div>
    </main>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  props: {
    /** Shows "Zum Login" below the content */
    loginLink: {type: Boolean, default: false},
  },
});
</script>

<style scoped>
.au-bg {
  min-height: 100%;
}

.au-page {
  max-width: 440px;
  gap: 14px;
  padding-top: 48px;
  padding-bottom: 32px;
}

.au-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 4px;
}

.au-logo {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #F2E791;
  color: #5C5200;
  display: grid;
  place-items: center;
  font-weight: 700;
  font-size: 15px;
}

.au-word {
  font-weight: 700;
  font-size: 19px;
  letter-spacing: -.01em;
  line-height: 1.2;
}

.au-word small {
  display: block;
  font-size: 11.5px;
  font-weight: 500;
  opacity: .62;
}

.au-foot {
  display: flex;
  justify-content: center;
}
</style>
<style src="@/components/acquisitionList/ui/acquisitionViews.css"></style>
<style src="@/components/auth/auth.css"></style>
